<script setup></script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="#2C57DE" fill-rule="evenodd" d="M15.589 4.41a.833.833 0 0 1 0 1.18l-10 10a.833.833 0 0 1-1.179-1.18l10-10a.833.833 0 0 1 1.179 0Z" clip-rule="evenodd"/><path fill="#2C57DE" fill-rule="evenodd" d="M4.41 4.41a.833.833 0 0 1 1.179 0l10 10a.833.833 0 0 1-1.179 1.18l-10-10a.833.833 0 0 1 0-1.18Z" clip-rule="evenodd"/></svg>
</template>
